import { Avatar } from '@mui/material'
import { useState } from 'react'
import { EmptyTable } from '../../../pages/subjects/Subject'
import { THead } from '../main/indicators-signals-table/IndicatorsSignalTable'

export const SettingsTableHead = () => {
  return (
    <THead>
      <tr>
        <td>Email</td>
      </tr>
    </THead>
  )
}

export const Empty = () => {
  return <EmptyTable name={'Setting'} />
}
export const NothingFound = () => {
  return (
    <tr>
      <td colSpan={1000} className={'nothing-found'}>
        Nothing Found ....
      </td>
    </tr>
  )
}

export const SettingsTableBody = (props: any) => {
  let [open, setOpen] = useState(false)
  let { search, onConnect } = props
  let index = props.ind
  let user = props.item
  // const {signals} = useAppSelector(state => state.data)
  // let signalChilds = getSignalsByIndicator(indicator, signals)
  const handleViewSignal = () => setOpen(!open)

  return (
    <tbody key={index}>
      <tr style={{ cursor: 'pointer' }} key={user._id}>
        <td>{user.email}</td>
      </tr>
    </tbody>
  )
}
